import { MessageCircle, Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeader } from "./SectionHeader";

export default function Contact() {
  return (
    <section id="contacto" className="py-20 md:py-28 bg-[var(--yellow)] border-y-2 border-[var(--ink)]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <SectionHeader
          eyebrow="Contacto"
          title="¿Tienes un texto que hacer muy fácil?"
          text="Cuéntanos qué necesitas adaptar y te explicamos cómo trabajarlo. Respondemos rápido y sin compromiso."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          <Reveal className="h-full">
            <a
              href="https://wa.me/34623409416"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              className="h-full flex flex-col gap-3 sketch bg-[var(--card)] p-7 hover:-translate-y-1 transition-transform shadow-[6px_6px_0_var(--ink)]"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 sketch-sm bg-[var(--green)] text-white">
                <MessageCircle className="w-6 h-6" aria-hidden="true" />
              </span>
              <h3 className="font-display font-bold text-xl">WhatsApp</h3>
              <p className="text-lg font-bold">623 409 416</p>
              <p className="text-base text-[var(--muted)]">Teléfono o WhatsApp. El que te resulte más fácil.</p>
              <span className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-[var(--blue-deep)]">
                Abrir chat <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.08} className="h-full">
            <a
              href="mailto:info@bilbaobianco.com"
              data-testid="contact-email"
              className="h-full flex flex-col gap-3 sketch bg-[var(--card)] p-7 hover:-translate-y-1 transition-transform shadow-[6px_6px_0_var(--ink)]"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 sketch-sm bg-[var(--blue)] text-white">
                <Mail className="w-6 h-6" aria-hidden="true" />
              </span>
              <h3 className="font-display font-bold text-xl">Email</h3>
              <p className="text-lg font-bold break-all">info@bilbaobianco.com</p>
              <p className="text-base text-[var(--muted)]">Escríbenos el texto y qué necesitas hacer con él.</p>
              <span className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-[var(--blue-deep)]">
                Enviar correo <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
              </span>
            </a>
          </Reveal>

          <Reveal delay={0.16} className="h-full sm:col-span-2 lg:col-span-1">
            <div className="h-full flex flex-col gap-3 sketch-2 bg-[var(--card)] p-7" data-testid="contact-address">
              <span className="inline-flex items-center justify-center w-12 h-12 sketch-sm bg-[var(--ink)] text-[var(--yellow)]">
                <MapPin className="w-6 h-6" aria-hidden="true" />
              </span>
              <h3 className="font-display font-bold text-xl">Visítanos</h3>
              <p className="text-base leading-relaxed font-bold">
                C/ Ildefonso Sánchez del Río 10, oficina 5,
                <br />
                33510 Pola de Siero, Asturias
              </p>
              <p className="text-base text-[var(--muted)] flex items-center gap-2">
                <Phone className="w-4 h-4 shrink-0" aria-hidden="true" />
                <a href="tel:+34623409416" data-testid="contact-phone" className="underline decoration-2 underline-offset-4 hover:text-[var(--blue-deep)]">
                  623 409 416
                </a>
              </p>
              <a
                href="https://www.google.com/maps/search/?api=1&query=C%2F%20Ildefonso%20S%C3%A1nchez%20del%20R%C3%ADo%2010%2C%20Pola%20de%20Siero%2C%20Asturias"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-maps"
                className="mt-auto inline-flex items-center gap-1 text-sm font-bold text-[var(--blue-deep)]"
              >
                Cómo llegar <ArrowUpRight className="w-4 h-4" aria-hidden="true" />
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-12">
          <figure className="sketch-2 bg-[var(--card)] overflow-hidden max-w-3xl" data-testid="contact-asturias">
            <img
              src="https://images.unsplash.com/photo-1732796724736-d4dd95baca0b?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Puente romano sobre un río en un paisaje verde de Asturias"
              className="w-full h-48 object-cover"
              loading="lazy"
            />
            <figcaption className="font-hand text-2xl px-6 py-4">De Pola de Siero y Langreo, para todo el mundo.</figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
